import { httpClient } from './http-client';
import { safariClient } from './safari-client';
import { isSafari } from '../helpers';
export var client = isSafari() ? safariClient : httpClient;
